import { render, staticRenderFns } from "./Receivers.vue?vue&type=template&id=31a1af99&scoped=true"
import script from "./Receivers.vue?vue&type=script&lang=js"
export * from "./Receivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a1af99",
  null
  
)

export default component.exports